<section class="overview">
    <div class="overview-header">
        <h1>Galerie</h1>
        <button class="primary" (click)="navigateNew()">Přidat obrázek</button>
    </div>

    <hr>

    <gallery-feature (imageSelected)="navigateImage($event)"></gallery-feature>
</section>